<template>
  <div class="page">
    <div class="container-fluid">
      
      <!-- Time Summary Header 

      Moving the relevant data into 

      <div class="row my-3">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body py-3">
              <div class="row text-center">
                <div :class="hasScheduledTime ? 'col-md-4' : 'col-md-12'">
                  <h6 class="text-muted mb-1 small">Work Time Today</h6>
                  <h3 class="mb-0 text-primary fw-bold">{{ workTimeToday }}</h3>
                </div>
                <div v-if="hasScheduledTime" class="col-md-4">
                  <h6 class="text-muted mb-1 small">Scheduled Time</h6>
                  <h3 class="mb-0 text-info fw-bold">{{ scheduledTime }}</h3>
                </div>
                <div v-if="hasScheduledTime" class="col-md-4">
                  <h6 class="text-muted mb-1 small">Remaining</h6>
                  <h3 class="mb-0 fw-bold" :class="remainingTimeClass">{{ remainingTime }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->
      <!-- Main Header -->
      <div class="row my-3 align-items-center">
        <div class="col-md-4">
          <h4 class="p-0 m-0">
            <span>My Tasks</span>
            <small class="text-muted ms-2">{{ formatDate(taskListDate) }}</small>
          </h4>
        </div>
        <div class="col-md-4">
          <!-- 
          <h4 class="mb-0 d-inline">
            <span class="mb-0 badge rounded-pill bg-primary">
              <small>Work: </small>
              {{ workTimeToday }}
          </span>
          </h4> &nbsp; -->

          <!-- 
          <h4 class="mb-0 d-inline">
          <span class="mb-0 badge rounded-pill bg-secondary">
              <small>Scheduled: </small>
              {{ scheduledTime }}
          </span>
          </h4>
          -->
        </div>
        <div class="col-md-4">
          <div class="d-flex justify-content-end align-items-center gap-2">
            <input 
              type="date" 
              class="form-control form-control-sm" 
              v-model="taskListDate"
              style="max-width: 160px;"
            />
            <button 
              @click="newClock()"
              class="btn btn-sm btn-outline-success rounded-0"
              title="Start New Clock"
            >
              <i class="fa fa-play"></i> <span class="d-none d-md-inline">Start Clock</span>
            </button>
            <button 
              @click="newTask()"
              class="btn btn-sm btn-outline-primary rounded-0"
              title="Add New Task"
            >
              <i class="fa fa-plus"></i> <span class="d-none d-md-inline">Add Task</span>
            </button>
            <button 
              @click="refreshAll()" 
              class="btn btn-sm btn-outline-secondary rounded-0"
              title="Refresh"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Side-by-Side Layout: Running Clocks (Left) | Scheduled Tasks (Right) -->
      <div class="row">
        <!-- Running Clocks Column -->
        <div class="col-md-6">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="m-0">
              <i class="fas fa-play-circle text-success me-2"></i>
              <span class="d-none d-md-inline">Running Clocks</span>
              <span class="d-inline d-md-none">Running</span>
              <span class="badge bg-success ms-2">{{ runningClocksList.length }}</span>
              <span v-if="loadingClocks" class="spinner-border spinner-border-sm text-success ms-2" role="status"></span>
            </h5>
            <h4 class="m-0">
            <span class="mb-0 badge rounded-pill bg-primary">
              <small>Work: </small>
              {{ workTimeToday }}
          </span>
          </h4>
          </div>
          
          <ul class="list-group">
            <li 
              v-if="runningClocksList.length === 0"
              class="text-center list-group-item rounded-0 mb-3 border py-4"
            >
              <em class="text-muted">No running clocks...</em><br />
              <a href="#" @click.prevent="newClock()" class="mt-2 d-inline-block">Start a Clock</a>
            </li>
            
            <li 
              v-for="task in runningClocksList"
              :key="'running-' + task.Id"
              class="list-group-item rounded-0 mb-3" 
              :class="{
                'running-clock': !task.Clock?.Paused,
                'paused-clock': task.Clock?.Paused
              }"
            >
              <!-- Running Clock Timer and Buttons -->
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                <!-- Running Clock Badge -->
                <div class="w-100 w-md-auto mb-2 mb-md-0">
                  <span class="badge me-2 fs-6" :class="task.Clock?.Paused ? 'bg-warning text-dark' : (task.isRequestClock ? 'bg-warning text-dark' : 'bg-success')">
                    <i class="fas fa-clock"></i> {{ task.Diff }}
                    <span v-if="task.Clock?.Paused"> (Paused: {{ task.DiffPaused }})</span>
                    <span v-if="task.isRequestClock && !task.Clock?.Paused"> (Request)</span>
                  </span>
                </div>
                
                <!-- Action Buttons -->
                <div class="d-flex gap-2 w-100 w-md-auto flex-wrap justify-content-start justify-content-md-end">
                  <!-- Project URL -->
                  <button 
                    v-if="hasURL(task)" 
                    class="btn btn-sm btn-outline-secondary -clock-action-btn px-3"
                    @click="goURL(task)"
                    title="Open Project URL"
                  >
                    <i class="fas fa-cloud"></i>
                  </button>
                  
                  <!-- Quick Add Dropdown 
                  <kt-dropmenu 
                    label="<i class='fa fa-plus'></i>"
                    btn-class="btn btn-sm btn-outline-secondary"
                    class="d-flex">
                    <template #dropmenu>
                      <div class="dropdown-menu show">
                      <a class="dropdown-item" href="#" @click.prevent="openQuickAdd('note', task)">
                        <i class="fa fa-sticky-note me-2"></i> Add Note
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="openQuickAdd('part', task)">
                        <i class="fa fa-cog me-2"></i> Add Part
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="openQuickAdd('expense', task)">
                        <i class="fa fa-dollar me-2"></i> Add Expense
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="openQuickAdd('mileage', task)">
                        <i class="fa fa-road me-2"></i> Add Mileage
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="openQuickAdd('file', task)">
                        <i class="fa fa-file me-2"></i> Add File
                      </a>
                      </div>
                    </template>
                  </kt-dropmenu>
                -->

                  <button
                    class="btn btn-sm btn-outline-info px-3"
                    title="Add Note"
                    @click.prevent="openQuickAdd('note', task)"
                  >
                  <i class="fa fa-sticky-note"></i> <!-- Add Note -->
                  </button>
                  
                  <!-- Pause / Resume -->
                  <button 
                    v-if="!task.Clock.Paused"
                    class="btn btn-sm btn-outline-warning -clock-action-btn px-3"
                    @click="pause(task)"
                    title="Pause"
                  >
                    <i class="fa fa-pause"></i>
                  </button>

                  <button 
                    v-else
                    class="btn btn-sm btn-outline-success -clock-action-btn px-3"
                    @click="showEditResume(task)"
                    title="Resume"
                  >
                    <i class="fa fa-play"></i>
                  </button>
                  
                  <!-- Switch Customer -->
                  <button 
                    v-if="!task.Clock.Paused"
                    class="btn btn-sm btn-outline-secondary -clock-action-btn px-3"
                    @click="switchCustomer(task)"
                    title="Switch Customer"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                  
                  <!-- Cancel Pause -->
                  <button 
                    v-if="task.Clock.Paused"
                    class="btn btn-sm btn-outline-secondary -clock-action-btn px-3"
                    @click="cancelPause(task)"
                    title="Cancel Pause"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  
                  <!-- Stop Clock -->
                  <button 
                    class="btn btn-sm btn-outline-danger -clock-action-btn px-3"
                    @click="stop(task)"
                    title="Stop Clock"
                  >
                    <i class="fa fa-stop"></i>
                  </button>
                </div>
              </div>

              <div class="row align-items-center">
                <!-- Task Info -->
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                  <div class="d-flex align-items-start">
                    <button 
                      class="btn btn-sm btn-link text-dark p-0 me-2 mt-1" 
                      @click="toggleRow(task)"
                    >
                      <i :class="task.Open ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </button>
                    
                    <div class="flex-grow-1">
                      <!-- Task Title -->
                      <div>
                        <button
                          data-to="/job/edit/ + task.Request?.Id" 
                          class="btn btn-sm -text-decoration-none -text-dark fw-bold"
                          @click="editJob(task.Request.Id)"
                        >
                          {{ task.Contact?.Company }}
                          <span class="text-muted ms-1"> / </span>
                          <span class="text-muted ms-1">{{ task.Contact?.Code }}{{ task.Request?.Id }}</span>
                      </button>
                      </div>
                      
                      <div class="text-muted small mt-1">
                        {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 d-flex justify-content-start justify-content-md-end mb-auto flex-wrap gap-2">
                      <!-- moving note to top row
                      <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('note', task)">
                        <i class="fa fa-sticky-note"></i> < ! - - Add Note - - >
                      </a>
                      -->
                      <!-- For Request clocks, only show note, file, and screenshot - no parts/expenses/mileage -->
                      <a v-if="!task.isRequestClock" class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('part', task)">
                        <i class="fa fa-puzzle-piece"></i> <!-- Add Part -->
                      </a>
                      <a v-if="!task.isRequestClock" class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('expense', task)">
                        <i class="fa fa-dollar"></i> <!-- Add Expense -->
                      </a>
                      <a v-if="!task.isRequestClock" class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('mileage', task)">
                        <i class="fa fa-car"></i> <!-- Add Mileage -->
                      </a>
                      <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('file', task)">
                        <i class="fa fa-file-pdf"></i> <!-- Add File -->
                      </a>
                      <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="capturePhoto(task)">
                        <i class="fa fa-camera"></i> <!-- Take Photo -->
                      </a>
                      <button
                        class="btn btn-sm btn-outline-primary"
                        title="Create Follow-up Task"
                        @click.prevent="followUpTask(task)"
                      >
                        <i class="fa fa-calendar-plus"></i>
                      </button>
                </div>
              </div>

              <!-- Expanded Details -->
              <div v-if="task.Open" class="row mt-3">
                <div class="col-12">
                  <div class="card bg-light">
                    <div class="card-body p-3">
                      <table class="table table-sm table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="text-muted" style="width: 150px;"><small>Client</small></td>
                            <td><small>{{ task.Contact?.Company }}</small></td>
                          </tr>
                          <tr v-if="task.WorkAssignment">
                            <td class="text-muted"><small>Task</small></td>
                            <td><small>{{ task.WorkAssignment }}</small></td>
                          </tr>
                          <tr>
                            <td class="text-muted"><small>Request</small></td>
                            <td>
                              <small>
                                <button class="btn btn-sm btn-link p-0" @click="switchCustomer(task)" title="Change Job">
                                  <i class="fa fa-edit"></i>
                                </button>
                                {{ task.Contact?.Code }}{{ task.Request?.Id }} -
                                {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                              </small>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-muted"><small>Started</small></td>
                            <td>
                              <small>
                                <button class="btn btn-sm btn-link p-0" @click="editStarted(task)" title="Edit Start Time">
                                  <i class="fa fa-edit"></i>
                                </button>
                                {{ dateTime(task.Clock?.Start) }}
                              </small>
                            </td>
                          </tr>
                          <tr v-if="task.Clock?.Paused">
                            <td class="text-muted"><small>Paused</small></td>
                            <td>
                              <small>
                                <button class="btn btn-sm btn-link p-0" @click="showEditPaused(task)" title="Edit Pause Time">
                                  <i class="fa fa-edit"></i>
                                </button>
                                {{ dateTime(task.Clock.Paused) }}
                              </small>
                            </td>
                          </tr>
                          <tr v-if="task.Clock?.TimePaused && task.Clock.TimePaused > 0">
                            <td class="text-muted"><small>Total Paused</small></td>
                            <td>
                              <small>
                                <button 
                                  v-if="task.PausedList && task.PausedList.length > 0"
                                  class="btn btn-sm btn-link p-0" 
                                  @click="togglePausedRows(task)"
                                  title="Show/Hide Pause History">
                                  <i :class="task.showPausedRows ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                                </button>
                                {{ ch.toHHMMSS(task.Clock.TimePaused) }}
                              </small>
                              <div v-if="task.showPausedRows && task.PausedList && task.PausedList.length > 0" class="mt-2">
                                <table class="table table-sm table-striped">
                                  <thead>
                                    <tr>
                                      <th style="width:1px;"></th>
                                      <th><small>Paused</small></th>
                                      <th><small>Resumed</small></th>
                                      <th><small>Time</small></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(p, index) in task.PausedList" :key="p.Id">
                                      <td style="width:1px;">
                                        <button
                                          v-if="index < task.PausedList.length - 1 || (index === task.PausedList.length - 1 && p.Resumed)"
                                          class="btn btn-sm btn-link p-0" 
                                          @click="deletePause(p.Id, task)"
                                          title="Delete Pause Record">
                                          <i class="fa fa-trash"></i>
                                        </button>
                                      </td>
                                      <td><small>{{ dateTime(p.Paused, 0, 1) }}</small></td>
                                      <td><small>{{ p.Resumed ? dateTime(p.Resumed, 0, 1) : 'Active' }}</small></td>
                                      <td><small>{{ p.Diff ? ch.toHHMMSS(p.Diff) : 'Active' }}</small></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="task.Notes && task.Notes.length > 0">
                            <td class="text-muted align-top"><small>Notes</small></td>
                            <td>
                              <div v-for="(note, idx) in task.Notes" :key="note.Id" class="mb-2">
                                <small>
                                  <button class="btn btn-sm btn-link p-0 me-1" @click="editNote(note, task)" title="Edit Note">
                                    <i class="fa fa-edit"></i>
                                  </button>
                                  <span class="text-muted">{{ dateTime(note.DateTaken, 0) }}</span> -
                                  {{ note.Note }}
                                </small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- Scheduled & Complete Column -->
        <div class="col-md-6">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="m-0">
              <i class="fas fa-list-check text-primary me-2"></i>
              <span class="d-none d-md-inline">Scheduled &amp; Complete</span>
              <span class="d-inline d-md-none">Scheduled</span>
              <span class="badge bg-primary ms-2">{{ scheduledTasksList.length + completedTasksList.length }}</span>
              <span v-if="loadingTasks" class="spinner-border spinner-border-sm text-primary ms-2" role="status"></span>
            </h5>
            <h4 class="m-0">
            <span class="mb-0 badge rounded-pill bg-secondary">
              <small class="d-none d-md-inline">Scheduled: </small>
              {{ scheduledTime }}
          </span>
          </h4>
          </div>
          
          <!-- Scheduled sub-section -->
          <div class="d-flex align-items-center mb-2">
            <small class="text-muted text-uppercase fw-semibold me-2">Scheduled</small>
            <span class="badge bg-secondary" style="font-size:0.7rem;">{{ scheduledTasksList.length }}</span>
          </div>

          <ul class="list-group">
            <li 
              v-if="scheduledTasksList.length === 0"
              class="text-center list-group-item rounded-0 mb-3 border py-4"
            >
              <em class="text-muted">No scheduled tasks...</em><br />
              <a href="#" @click.prevent="newTask()" class="mt-2 d-inline-block">Add New Task</a>
            </li>
            
            <li 
              v-for="task in scheduledTasksList"
              :key="'scheduled-' + task.Id"
              class="list-group-item rounded-0 mb-3 scheduled-task"
            >
              <div class="row align-items-center">
                <!-- Task Info -->
                <div class="col-md-8">
                  <div class="d-flex align-items-start">
                    <button 
                      class="btn btn-sm btn-link text-dark p-0 me-2 mt-1" 
                      @click="toggleRow(task)"
                    >
                      <i :class="task.Open ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </button>
                    
                    <div class="flex-grow-1">
                      <!-- Task Title with inline time -->
                      <div class="d-flex align-items-baseline gap-2">
                        <span v-if="task.CompleteByDate" class="text-primary small fw-semibold text-nowrap">
                          <i class="fas fa-clock me-1"></i>{{ formatScheduledTime(task.CompleteByDate) }}
                        </span>
                        <button
                          data-to="/job/edit/ + task.Request?.Id" 
                          class="text-decoration-none text-dark fw-bold btn btn-sm p-0"
                        >
                          {{ task.Contact?.Company }}
                        </button>
                        <span class="text-muted small">{{ task.Contact?.Code }}{{ task.Request?.Id }}</span>
                      </div>
                      
                      <div class="text-muted small mt-1">
                        {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                      </div>
                      
                      <div v-if="task.WorkAssignment" class="text-muted small">
                        <i class="fas fa-tasks me-1"></i>{{ task.WorkAssignment }}
                        <span v-if="task.EstimatedTime"> - {{ task.EstimatedTime }} hrs</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- Action Buttons for Scheduled Tasks -->
                <div class="col-md-4 text-end mt-3 mt-md-0">
                  <div class="btn-group" role="group">
                    <button 
                      class="btn btn-sm btn-outline-secondary -rounded-2"
                      @click="editTask(task.Id)"
                      title="Edit Task"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button 
                      class="btn btn-sm btn-success -rounded-0"
                      @click="startTask(task.Id)"
                      title="Start Clock"
                    >
                      <i class="fa fa-play"></i> Start
                    </button>
                  </div>
                </div>
              </div>

              <!-- Expanded Details -->
              <div v-if="task.Open" class="row mt-3">
                <div class="col-12">
                  <div class="card bg-light">
                    <div class="card-body p-3">
                      <table class="table table-sm table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="text-muted" style="width: 150px;"><small>Client</small></td>
                            <td><small>{{ task.Contact?.Company }}</small></td>
                          </tr>
                          <tr v-if="task.WorkAssignment">
                            <td class="text-muted"><small>Task</small></td>
                            <td><small>{{ task.WorkAssignment }}</small></td>
                          </tr>
                          <tr>
                            <td class="text-muted"><small>Request</small></td>
                            <td>
                              <small>
                                {{ task.Contact?.Code }}{{ task.Request?.Id }} -
                                {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                              </small>
                            </td>
                          </tr>
                          <tr v-if="task.EstimatedTime">
                            <td class="text-muted"><small>Estimated</small></td>
                            <td><small>{{ task.EstimatedTime }} hours</small></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <!-- Work Complete sub-section -->
          <div v-if="completedTasksList.length > 0" class="d-flex align-items-center mt-3 mb-2">
            <small class="text-muted text-uppercase fw-semibold me-2">Work Complete</small>
            <span class="badge bg-purple" style="font-size:0.7rem;">{{ completedTasksList.length }}</span>
          </div>

          <ul v-if="completedTasksList.length > 0" class="list-group">
            <li 
              v-for="task in completedTasksList"
              :key="'complete-' + task.Id"
              class="list-group-item rounded-0 mb-3 complete-task"
            >
              <!-- Header row: checkmark badge + action buttons -->
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                <!-- Check badge + RefFlags -->
                <div class="w-100 w-md-auto mb-2 mb-md-0 d-flex align-items-center gap-2">
                  <span class="badge bg-purple fs-6">
                    <i class="fas fa-check-circle"></i> Task Complete
                  </span>
                  <span class="d-flex align-items-center gap-1 ms-1" v-if="task.Request">
                    <Flag v-if="task.Request.RefFlags & 1" :size="16" fill="lightgreen" color="grey" title="Has Running Clock" />
                    <Flag v-if="task.Request.RefFlags & 2" :size="16" fill="orange" color="grey" title="Has Paused Clock" />
                    <Flag v-if="task.Request.RefFlags & 4" :size="16" fill="lightblue" color="grey" title="Has Active Follow-Up" />
                    <Flag v-if="task.Request.RefFlags & 8" :size="16" fill="yellow" color="grey" title="Has Overdue Follow-Up" />
                    <Flag v-if="!(task.Request.RefFlags & 14) && !isJobClosed(task)" :size="16" fill="red" color="grey" title="No Follow-Up" />
                    <Flag v-if="isJobClosed(task)" :size="16" fill="#6f42c1" color="grey" title="Job Closed" />
                  </span>
                </div>

                <!-- Quick-add buttons (mirrors running clock row, no clock controls) -->
                <div class="d-flex gap-2 w-100 w-md-auto flex-wrap justify-content-start justify-content-md-end">
                  <button
                    class="btn btn-sm btn-outline-info px-3"
                    title="Add Note"
                    @click.prevent="openQuickAdd('note', task)"
                  >
                    <i class="fa fa-sticky-note"></i>
                  </button>
                  <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('part', task)">
                    <i class="fa fa-puzzle-piece"></i>
                  </a>
                  <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('expense', task)">
                    <i class="fa fa-dollar"></i>
                  </a>
                  <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('mileage', task)">
                    <i class="fa fa-car"></i>
                  </a>
                  <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="openQuickAdd('file', task)">
                    <i class="fa fa-file-pdf"></i>
                  </a>
                  <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="capturePhoto(task)">
                    <i class="fa fa-camera"></i>
                  </a>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    title="Create Follow-up Task"
                    @click.prevent="followUpTask(task)"
                  >
                    <i class="fa fa-calendar-plus"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary px-3"
                    @click="editTask(task.Id)"
                    title="Edit Task"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                </div>
              </div>

              <!-- Task info row -->
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="d-flex align-items-start">
                    <button 
                      class="btn btn-sm btn-link text-dark p-0 me-2 mt-1" 
                      @click="toggleRow(task)"
                    >
                      <i :class="task.Open ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </button>
                    
                    <div class="flex-grow-1">
                      <div>
                        <button
                          class="btn btn-sm fw-bold"
                          @click="editJob(task.Request?.Id)"
                        >
                          {{ task.Contact?.Company }}
                          <span class="text-muted ms-1"> / </span>
                          <span class="text-muted ms-1">{{ task.Contact?.Code }}{{ task.Request?.Id }}</span>
                        </button>
                      </div>
                      <div class="text-muted small mt-1">
                        {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                      </div>
                      <div v-if="task.WorkAssignment" class="text-muted small">
                        <i class="fas fa-tasks me-1"></i>{{ task.WorkAssignment }}
                        <span v-if="task.ActualTime"> &mdash; {{ task.ActualTime }} hrs logged</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Expanded Details -->
              <div v-if="task.Open" class="row mt-3">
                <div class="col-12">
                  <div class="card bg-light">
                    <div class="card-body p-3">
                      <table class="table table-sm table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="text-muted" style="width: 150px;"><small>Client</small></td>
                            <td><small>{{ task.Contact?.Company }}</small></td>
                          </tr>
                          <tr v-if="task.WorkAssignment">
                            <td class="text-muted"><small>Task</small></td>
                            <td><small>{{ task.WorkAssignment }}</small></td>
                          </tr>
                          <tr>
                            <td class="text-muted"><small>Request</small></td>
                            <td>
                              <small>
                                {{ task.Contact?.Code }}{{ task.Request?.Id }} -
                                {{ task.Request?.RequestDetailedDescription || task.Request?.TaskDetail }}
                              </small>
                            </td>
                          </tr>
                          <tr v-if="task.ActualTime">
                            <td class="text-muted"><small>Time Logged</small></td>
                            <td><small>{{ task.ActualTime }} hours</small></td>
                          </tr>
                          <tr v-if="task.WorkCompleteDate">
                            <td class="text-muted"><small>Completed</small></td>
                            <td><small>{{ (console.log('Display WorkCompleteDate:', task.WorkCompleteDate, 'Formatted:', dateTime(task.WorkCompleteDate)), dateTime(task.WorkCompleteDate)) }}</small></td>
                          </tr>
                          <tr v-if="task.ActualWork">
                            <td class="text-muted align-top"><small>Work Done</small></td>
                            <td><small>{{ task.ActualWork }}</small></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!-- Clock Wizard Modal -->
    <kt-modal :title="modalTitle" :visible="modalVisible" @dismiss="modalDismiss()">
      <template #body>
        <clock-wizard
          :operation="clockOperation"
          :task-id="clockTaskId"
          @cancel="modalDismiss"
          @success="clockSuccess"
        ></clock-wizard>
      </template>
    </kt-modal>

    <!-- Resume Clock Wizard Modal -->
    <kt-modal title="Resume Clock" :visible="resumeModalVisible" @dismiss="resumeModalDismiss()">
      <template #body>
        <clock-resume-wizard
          v-if="resumeTaskData"
          :task="resumeTaskData"
          @cancel="resumeModalDismiss"
          @success="resumeSuccess"
        ></clock-resume-wizard>
      </template>
    </kt-modal>

    <!-- Quick Add Modal -->
    <kt-modal :title="quickAddTitle" :visible="quickAddVisible" @dismiss="quickAddDismiss()">
      <template #body>
        <component 
          :is="quickAddComponent"
          v-if="quickAddComponent"
          :task-id="quickAddTask?.Id"
          :request-id="quickAddTask?.isRequestClock ? undefined : quickAddRequestId"
          :work-order-id="quickAddTask?.isRequestClock ? quickAddRequestId : undefined"
          :client-id="quickAddClientId"
          :tech-id="quickAddTechId"
          :embedded="true"
          @cancel="quickAddDismiss"
          @saved="quickAddSaved"
        />
      </template>
    </kt-modal>

    <!-- Form Modal (for notes and clock switching) -->
    <kt-modal :title="formTitle" :visible="formVisible" @dismiss="formDismiss()">
      <template #body>
        <div v-if="formType == 'clock'" class="">
          <clock-form 
            v-model="clockModel" 
            :mode="clockMode"
          ></clock-form>
        </div>
        <div v-if="formType == 'note'" class="">
          <note-form v-model="noteModel"></note-form>
          <div class="row mt-3">
            <div class="col-6">
              <button class="form-control btn btn-sm btn-outline-secondary" @click="formDismiss()">
                Cancel
              </button>
            </div>
            <div class="col-6">
              <button class="form-control btn btn-sm btn-outline-primary" @click="saveRecord()">
                Save
              </button>
            </div>
          </div>
        </div>
      </template>
    </kt-modal>

    <!-- Extra Modal (for editing start/pause times) -->
    <kt-modal :title="extraTitle" @dismiss="extraDismiss()" :visible="extraVisible">
      <template #body>
        <!-- Edit Paused Time -->
        <div class="row" v-if="extraType == 'pause'">
          <div class="col-12 mb-3">
            <kt-input 
              type="date" 
              label="Edit Paused Date" 
              v-model="pauseDate"
            ></kt-input>
            
            <kt-input 
              class="mt-2" 
              type="time" 
              label="Edit Paused Time" 
              v-model="pauseTime"
            ></kt-input>
          </div>
          <div class="col-6">
            <button 
              class="btn btn-sm btn-outline-secondary form-control" 
              @click="extraDismiss()"
            >
              Cancel
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-sm btn-outline-primary form-control" @click="setPaused()">
              Set
            </button>
          </div>
        </div>

        <!-- Edit Start Time -->
        <div class="row" v-if="extraType == 'start'">
          <div class="col-12 mb-3">
            <kt-input 
              type="date" 
              label="Edit Start Date" 
              v-model="startDate"
            ></kt-input>
            
            <kt-input 
              class="mt-2" 
              type="time" 
              label="Edit Start Time" 
              v-model="startTime"
            ></kt-input>
          </div>
          <div class="col-6">
            <button class="btn btn-sm btn-outline-secondary form-control" @click="extraDismiss()">
              Cancel
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-sm btn-outline-primary form-control" @click="setStarted()">
              Set
            </button>
          </div>
        </div>
      </template>
    </kt-modal>

    <!-- Hidden camera input for mobile photo capture -->
    <input 
      type="file" 
      ref="cameraInput" 
      accept="image/*" 
      capture="environment" 
      class="d-none" 
      @change="onPhotoCaptured"
    />

    <!-- Webcam Capture Modal (desktop) -->
    <kt-modal title="Take Photo" :visible="webcamVisible" @dismiss="closeWebcam()" size="modal-lg">
      <template #body>
        <div class="text-center">
          <!-- Live webcam feed -->
          <div v-if="!capturedImageData" class="position-relative">
            <video ref="webcamVideo" autoplay playsinline class="w-100 rounded" style="max-height: 400px; background: #000;"></video>
            <div class="mt-3">
              <button class="btn btn-primary btn-lg" @click="takeSnapshot">
                <i class="fa fa-camera me-2"></i>Take Photo
              </button>
            </div>
          </div>
          <!-- Preview of captured photo -->
          <div v-else>
            <img :src="capturedImageData" class="w-100 rounded" style="max-height: 400px; object-fit: contain;" />
            <div class="mt-3 d-flex justify-content-center gap-2">
              <button class="btn btn-outline-secondary" @click="retakePhoto">
                <i class="fa fa-undo me-2"></i>Retake
              </button>
              <button class="btn btn-success" @click="uploadWebcamPhoto" :disabled="isUploadingPhoto">
                <i class="fa fa-upload me-2"></i>{{ isUploadingPhoto ? 'Uploading...' : 'Upload Photo' }}
              </button>
            </div>
          </div>
        </div>
        <canvas ref="webcamCanvas" class="d-none"></canvas>
      </template>
    </kt-modal>
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import Api from "@/services/Api";
import ApiService from "@/services/ApiService";
import Alert from "@/services/Alert";
import Toast from "@/services/Toast";
import Cache from "@/services/Cache";
import Helper, { DateFormat } from "@/services/Helper"
import OldHelper from "@/services/Helper.DEPRECATED.js";
import Events from "@/services/Emitter";
import ClockHelper from "@/components/Clock/ClockHelper.ts";

import KtModal from "@/components/UI/KtModal.vue";
import KtInput from "@/components/UI/KtInput.vue";
import KtDropmenu from "@/components/UI/KtDropmenu.vue";
import ClockWizard from "@/components/Clock/ClockWizard.vue";
import ClockResumeWizard from "@/components/Clock/ClockResumeWizard.vue";
import ClockForm from "@/components/Clock/ClockForm.vue";
import NoteForm from "@/components/Notes/NoteForm.vue";
import NoteEdit from "@/components/Notes/NoteEdit.vue";
import PartEdit from "@/components/Parts/PartEdit.vue";
import ExpenseEdit from "@/components/Expenses/ExpenseEdit.vue";
import MileageEdit from "@/components/Mileage/MileageEdit.vue";
import AttachmentForm from "@/components/Attachments/AttachmentForm.vue";

import { useAppStore } from "@/stores/AppStore";
import { Flag } from 'lucide-vue-next';

// Services & Helpers
const ch = new ClockHelper();
const appStore = useAppStore();
const isJobClosed = (task) => {
  const status = task.Request?.RequestStatus;
  if (status === null || status === undefined) return false;
  return !(status === 1 || status === 11 || status === 12 || status === 13 || status === 14 || status === 22);
};
const route = useRoute();
const router = useRouter();
const unbind: Array<Function> = [];

const formatScheduledTime = (dateStr: string): string => {
  if (!dateStr) return '';
  const d = Helper.dateFromString(dateStr);
  if (!d) return '';
  return dayjs(d).format('h:mm A');
};

// State
const taskListDate = ref(Helper.dateToInput(new Date(), DateFormat.Date));
const runningClocks = ref([]);
const scheduledTasks = ref([]);
const reload = ref(false);
const loadingClocks = ref(false);
const loadingTasks = ref(false);
const running = ref<number | null>(null);
const ticks = ref(0);
const editRow = ref(null);

// Modal State
const modalTitle = ref("Start Clock");
const modalVisible = ref(false);
const clockOperation = ref("start");
const clockTaskId = ref(null);

// Resume Wizard Modal State
const resumeModalVisible = ref(false);
const resumeTaskData = ref(null);

// Quick Add Modal State
const quickAddVisible = ref(false);
const quickAddTitle = ref("");
const quickAddComponent = ref(null);
const quickAddRequestId = ref(0);
const quickAddClientId = ref(0);
const quickAddTechId = ref(0);
const quickAddTask = ref(null);

// Edit Forms Modal State
const formVisible = ref(false);
const formTitle = ref("Add Note");
const formType = ref("note");
const clockModel = ref({});
const clockMode = ref(1);
const noteModel = ref({});

// Extra Modal State (for editing start/pause times)
const extraVisible = ref(false);
const extraTitle = ref("");
const extraType = ref("");
const startTime = ref("");
const startDate = ref("");
const pauseTime = ref("");
const pauseDate = ref("");

// Track which tasks are open
const openTasks = ref({});
const showPausedRowsMap = ref({});

// Helper: Check if a task is a Request-based clock (WorkOrder without Job)
const isRequestClock = (task) => {
  // Request-based clocks have Clock.RequestId but no Task.RequestId (Job)
  return task.Clock?.RequestId && !task.RequestId;
};

// Computed: Running clocks list for left column
const runningClocksList = computed(() => {
  return runningClocks.value.map(clock => ({
    ...clock,
    isRunning: true,
    isRequestClock: isRequestClock(clock),
    Open: openTasks.value[clock.Id] || false,
    showPausedRows: showPausedRowsMap.value[clock.Id] || false
  }));
});

// Helper: determine if a task is assignment-only (not yet worked)
const isAssignment = (task) => {
  const hasWork =
    (task.ActualTime != null && task.ActualTime !== 0) ||
    (task.ActualWork != null && task.ActualWork !== "") ||
    (task.Status != null && task.Status !== 0) ||
    (task.InvoiceAmount != null && task.InvoiceAmount !== 0) ||
    (task.ShouldBill != null && task.ShouldBill !== 0) ||
    (task.InvoiceText != null && task.InvoiceText !== "") ||
    (task.WorkCompleteDate != null);
  return !hasWork;
};

// Helper: Get date range for the selected task list date
const taskListDateRange = computed(() => {
  const date = Helper.dateFromString(taskListDate.value) || new Date();
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return { start, end };
});

// Computed: Scheduled tasks list for right column - tasks scheduled for the selected date
// Filters by CompleteByDate matching the selected date
const scheduledTasksList = computed(() => {
  const { start, end } = taskListDateRange.value;
  return scheduledTasks.value
    .filter(task => {
      // Exclude running clocks
      if (runningClocks.value.some(c => c.Id === task.Id)) return false;
      // Must be an assignment (not yet worked)
      if (!isAssignment(task)) return false;
      // Must be scheduled for the selected date
      if (!task.CompleteByDate) return false;
      // Parse date-only string (e.g., "2026-05-26") as local date to match taskListDateRange
      // Append "T00:00:00" to force local timezone interpretation instead of UTC
      const dateStr = task.CompleteByDate.includes('T')
        ? task.CompleteByDate
        : task.CompleteByDate + 'T00:00:00';
      const scheduledDate = new Date(dateStr);
      return scheduledDate >= start && scheduledDate <= end;
    })
    .map(task => ({
      ...task,
      isRunning: false,
      Open: openTasks.value[task.Id] || false,
      showPausedRows: showPausedRowsMap.value[task.Id] || false
    }))
    .sort((a, b) => {
      if (!a.CompleteByDate && !b.CompleteByDate) return 0;
      if (!a.CompleteByDate) return 1;
      if (!b.CompleteByDate) return -1;
      const da = Helper.dateFromString(a.CompleteByDate);
      const db = Helper.dateFromString(b.CompleteByDate);
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da.getTime() - db.getTime();
      /*
      // Sort by CompleteByDate (Start By time), earliest first
      if (!a.CompleteByDate && !b.CompleteByDate) return 0;
      if (!a.CompleteByDate) return 1; // Tasks without date go to end
      if (!b.CompleteByDate) return -1;
      return new Date(a.CompleteByDate).getTime() - new Date(b.CompleteByDate).getTime();
      */
    });
});

// Computed: Work-complete tasks list for right column (tasks completed on the selected date)
// Filters by WorkCompleteDate matching the selected date, sorted by completion time
const completedTasksList = computed(() => {
  const { start, end } = taskListDateRange.value;
  
  // DEBUG LOGGING
  console.log('=== completedTasksList DEBUG ===');
  console.log('Date range:', { start: start.toISOString(), end: end.toISOString() });
  console.log('scheduledTasks count:', scheduledTasks.value.length);
  console.log('runningClocks count:', runningClocks.value.length);
  
  scheduledTasks.value.forEach(task => {
    console.log(`Task ${task.Id}: WorkCompleteDate=${task.WorkCompleteDate}, isAssignment=${isAssignment(task)}, hasRunningClock=${runningClocks.value.some(c => c.Id === task.Id)}`);
  });
  // END DEBUG
  
  const filtered = scheduledTasks.value
    .filter(task => {
      // Exclude running clocks
      if (runningClocks.value.some(c => c.Id === task.Id)) {
        console.log(`Task ${task.Id} filtered OUT: has running clock`);
        return false;
      }
      // Must have logged work (not an assignment)
      if (isAssignment(task)) {
        console.log(`Task ${task.Id} filtered OUT: isAssignment=true (no work logged yet)`);
        return false;
      }
      // Must have been completed on the selected date
      if (!task.WorkCompleteDate) {
        console.log(`Task ${task.Id} filtered OUT: no WorkCompleteDate`);
        return false;
      }
      // Parse date-only string (e.g., "2026-05-26") as local date to match taskListDateRange
      // Append "T00:00:00" to force local timezone interpretation instead of UTC
      const dateStr = task.WorkCompleteDate.includes('T') 
        ? task.WorkCompleteDate 
        : `${task.WorkCompleteDate}T00:00:00`;
      const completedDate = new Date(dateStr);
      const inRange = completedDate >= start && completedDate <= end;
      if (!inRange) {
        console.log(`Task ${task.Id} filtered OUT: date ${completedDate.toISOString()} not in range ${start.toISOString()} to ${end.toISOString()}`);
      } else {
        console.log(`Task ${task.Id} INCLUDED: date ${completedDate.toISOString()} is in range`);
      }
      return inRange;
    });
  
  console.log(`completedTasksList result: ${filtered.length} tasks`);
  
  return filtered
    .map(task => ({
      ...task,
      isRunning: false,
      Open: openTasks.value[task.Id] || false,
      showPausedRows: showPausedRowsMap.value[task.Id] || false
    }))
    .sort((a, b) => {
      // Sort by WorkCompleteDate, newest first (most recently completed at top)
      if (!a.WorkCompleteDate && !b.WorkCompleteDate) return 0;
      if (!a.WorkCompleteDate) return 1;
      if (!b.WorkCompleteDate) return -1;
      return new Date(b.WorkCompleteDate).getTime() - new Date(a.WorkCompleteDate).getTime();
    });
});

// Computed: Combine running clocks and scheduled tasks (kept for compatibility)
const allTasks = computed(() => {
  return [...runningClocksList.value, ...scheduledTasksList.value];
});

// Computed: Time summaries
const workTimeToday = computed(() => {
  let totalSeconds = 0;
  
  runningClocks.value.forEach(clock => {
    if (clock.DiffSeconds) {
      totalSeconds += clock.DiffSeconds;
    }
  });
  
  return ch.toHHMMSS(totalSeconds);
});

const scheduledTime = computed(() => {
  let totalHours = 0;
  
  scheduledTasks.value.forEach(task => {
    if (task.EstimatedTime) {
      totalHours += parseFloat(task.EstimatedTime);
    }
  });
  
  const totalSeconds = totalHours * 3600;
  return ch.toHHMMSS(totalSeconds);
});

const hasScheduledTime = computed(() => {
  return scheduledTasks.value.some(task => task.EstimatedTime && parseFloat(task.EstimatedTime) > 0);
});

const remainingTime = computed(() => {
  let workSeconds = 0;
  let scheduledSeconds = 0;
  
  runningClocks.value.forEach(clock => {
    if (clock.DiffSeconds) {
      workSeconds += clock.DiffSeconds;
    }
  });
  
  scheduledTasks.value.forEach(task => {
    if (task.EstimatedTime) {
      scheduledSeconds += parseFloat(task.EstimatedTime) * 3600;
    }
  });
  
  const remaining = scheduledSeconds - workSeconds;
  
  // Show actual remaining time (positive = time left, negative = over time)
  if (remaining >= 0) {
    return ch.toHHMMSS(remaining);
  } else {
    return "-" + ch.toHHMMSS(Math.abs(remaining));
  }
});

const remainingTimeClass = computed(() => {
  let workSeconds = 0;
  let scheduledSeconds = 0;
  
  runningClocks.value.forEach(clock => {
    if (clock.DiffSeconds) {
      workSeconds += clock.DiffSeconds;
    }
  });
  
  scheduledTasks.value.forEach(task => {
    if (task.EstimatedTime) {
      scheduledSeconds += parseFloat(task.EstimatedTime) * 3600;
    }
  });
  
  const remaining = scheduledSeconds - workSeconds;
  
  if (remaining > 0) return 'text-success';
  if (remaining < 0) return 'text-danger';
  return 'text-muted';
});

// Helper Functions
const formatDate = (dateStr) => {
  return dayjs(dateStr).format('MMM D, YYYY');
};

const dateTime = (val, z, s) => {
  if (!val) return "";
  const format = s ? "MM/DD/YYYY h:mm:ssa" : "MM/DD/YYYY h:mma";
  return dayjs(val + (z ? "Z" : "")).format(format);
};

const hasURL = (task) => {
  return task.Request?.ProjectFolder && task.Request.ProjectFolder.includes('https://');
};

const goURL = (task) => {
  window.open(task.Request.ProjectFolder, "_blank");
};

const toggleRow = (task) => {
  openTasks.value[task.Id] = !openTasks.value[task.Id];
};

const togglePausedRows = (task) => {
  showPausedRowsMap.value[task.Id] = !showPausedRowsMap.value[task.Id];
};

// Navigation Functions
const editJob = (id) => {
  
  Events.emit("edit:job", id);
};


const newClock = () => {
  // Open the ClockWizard modal to allow selection of job and task/assignment
  Events.emit('new:clock', {});
};

const newTask = () => {
  // Events.emit("redirect", "/time/edit/new");
  Events.emit("open:taskForm");
};

const startTask = (id) => {
  // Open ClockWizard with the task pre-selected
  Events.emit('new:clock', { taskId: id });
};

const editTask = (id) => {
  Events.emit("open:taskForm", id);
  // Events.emit("redirect", "/time/edit/" + id);
};

const followUpTask = (task) => {
  Events.emit("open:taskForm", {
    id: null,
    requestId: task.RequestId || task.Request?.Id || null,
    clientId: task.Contact?.CustomerNumber || null,
    techId: task.AssignedTo || null,
    workAssignment: task.WorkAssignment || ''
  });
};

const stop = (task) => {
  Events.emit("redirect", "/clock/stop/" + task.Id);
};

// Placeholder functions - will implement in next parts
const addNote = (task) => {
  console.log("addNote", task);
};

const editNote = async (note, task) => {
  formVisible.value = true;
  formTitle.value = "Edit Note";
  formType.value = "note";

  let tmp = await Api.loadNote(note.Id);
  noteModel.value = tmp;
  
  // Populate all required fields from task context
  if (task) {
    noteModel.value.TaskId = task.Id;
    noteModel.value.RequestId = task.Request?.Id || task.RequestId;
    noteModel.value.ClientId = task.Contact?.Id || task.ClientId;
    noteModel.value.UserId = appStore.account?.user?.UserId;
  }
};

const formDismiss = () => {
  formVisible.value = false;
};

const extraDismiss = () => {
  extraType.value = "";
  extraTitle.value = "";
  extraVisible.value = false;
};

const extraSave = async () => {
  if (extraType.value === "start") {
    await setStarted();
  } else if (extraType.value === "pause") {
    await setPaused();
  }
};

const saveRecord = async () => {
  switch (formType.value) {
    case "note":
      let pay = {
        TaskId: noteModel.value.TaskId,
        ClientId: noteModel.value.ClientId,
        DateTaken: new Date(noteModel.value.DateTaken),
        Note: noteModel.value.Note,
        RequestId: noteModel.value.RequestId,
        UserId: noteModel.value.UserId
      };

      if (noteModel.value.Id) {
        pay.Id = noteModel.value.Id;
      }

      await Api.saveNote(pay);
      formDismiss();
      
      // Reload to show updated note
      reload.value = true;
      await loadClocks();
      Toast.success("Note saved");
      break;
  }
};

/**
 * Pauses a running clock
 */
const pause = async (task) => {
  console.log("=== PAUSE CLOCK ===");
  console.log("Task:", task);
  console.log("Clock ID:", task.Clock?.Id);
  console.log("Clock Paused flag before:", task.Clock?.Paused);
  
  try {
    const now = new Date();
    console.log("Pause time:", now);
    
    // Copy the clock to avoid mutating the original
    const clock = OldHelper.copy(task.Clock);
    clock.Paused = now;
    console.log("Clock object to save:", clock);
    
    // Save the updated clock
    const savedClock = await Api.saveClock(clock);
    console.log("Clock saved response:", savedClock);
    console.log("Clock saved response type:", typeof savedClock);
    console.log("Clock saved response keys:", savedClock ? Object.keys(savedClock) : "null");
    console.log("Saved clock Paused property:", savedClock?.Paused);
    
    // Create a ClockPause record
    const pauseRecord = {
      ClockId: task.Clock.Id,
      Paused: now
    };
    console.log("Pause record to save:", pauseRecord);
    const savedPause = await Api.savePause(pauseRecord);
    console.log("Pause record saved response:", savedPause);
    
    // Reload clocks to show updated state
    reload.value = true;
    await loadClocks();
    
    // Verify the clock was updated
    const reloadedClock = runningClocks.value.find(c => c.Id === task.Id);
    console.log("Reloaded clock after pause:", reloadedClock);
    console.log("Reloaded clock.Clock.Paused:", reloadedClock?.Clock?.Paused);
    
    console.log("=== PAUSE COMPLETE ===");
  } catch (error) {
    console.error("Error pausing clock:", error);
    Alert.notify("Failed to pause clock");
  }
};

/**
 * Shows the resume wizard modal for a paused clock
 */
const showEditResume = (task) => {
  console.debug("showEditResume()", task);
  resumeTaskData.value = task;
  resumeModalVisible.value = true;
};

/**
 * Cancels the current pause (clears pause flag but doesn't delete the pause record)
 */
const cancelPause = async (task) => {
  console.debug("cancelPause()", task);
  
  try {
    const clock = task.Clock;
    clock.Paused = null;
    
    await Api.saveClock(clock);
    
    // Reload the list
    reload.value = true;
    await loadClocks();
    
    Alert.notify("Pause cancelled", "info");
  } catch (error) {
    console.error("Error cancelling pause:", error);
    Alert.notify("Failed to cancel pause");
  }
};

const switchCustomer = (task) => {
  console.debug("switch", task);

  let obj = {
    Task: task.Id,
    Client: task.Contact.CustomerNumber,
    Job: task.RequestId,
    Date: Helper.dateToInput(new Date(task.Clock.Start), Helper.DateFormat_Date),
    Time: Helper.dateToInput(new Date(task.Clock.Start), Helper.DateFormat_Time),
    Rate: task.Clock.Rate,
    Clock: task.Clock.Id,
  };

  clockModel.value = obj;
  formType.value = "clock";
  clockMode.value = 2;
  formVisible.value = true;
  formTitle.value = "Switch Customer";
};

const editStarted = (task) => {
  // Show the modal to edit start time
  editRow.value = task;
  let tmp = new Date(task.Clock.Start);
  startTime.value = Helper.dateToInput(tmp, Helper.DateFormat_Time);
  startDate.value = Helper.dateToInput(tmp, Helper.DateTime_Date);
  extraType.value = "start";
  extraTitle.value = "Edit Started";
  extraVisible.value = true;
};

const setStarted = async () => {
  // Update the clock start time
  let task = editRow.value;
  if (!task) return;
  
  let newStart = new Date(startDate.value + " " + startTime.value);
  let clockData = await Api.loadClock(task.Clock.Id);
  let clock = clockData.Clock;
  clock.Start = newStart;
  await Api.saveClock(clock);

  // Close the modal
  extraType.value = "";
  extraTitle.value = "";
  extraVisible.value = false;

  // Reload clocks
  reload.value = true;
  await loadClocks();
  Toast.success("Start time updated");
};

const showEditPaused = (task) => {
  // Show the modal to edit pause time
  editRow.value = task;
  let tmp = new Date(task.Clock.Paused);
  pauseDate.value = Helper.dateToInput(tmp, Helper.DateFormat_Date);
  pauseTime.value = Helper.dateToInput(tmp, Helper.DateFormat_TimeWithSeconds);
  extraType.value = "pause";
  extraTitle.value = "Edit Paused";
  extraVisible.value = true;
};

const setPaused = async () => {
  // Update the clock pause time
  let task = editRow.value;
  if (!task) return;
  
  let newPaused = new Date(pauseDate.value + " " + pauseTime.value);
  let clock = OldHelper.copy(task.Clock);
  clock.Paused = newPaused;
  
  await Api.saveClock(clock);

  // load the last pause and update it...
  if (!task) return;
  let lastPause = await Api.loadLastPause(task.Clock.Id);
  
  if (lastPause) {
    lastPause.Paused = newPaused;
    await Api.savePause(lastPause);
  }
  
  // Close the modal
  extraType.value = "";
  extraTitle.value = "";
  extraVisible.value = false;

  // Reload clocks
  reload.value = true;
  await loadClocks();
};

const deletePause = async (id, task) => {
  Alert.confirm("Are you sure you want to remove that record?", async () => {
    await Api.deletePause(id);

    // Load all other pauses and recalculate total
    let rows = await Api.loadPauses(task.Clock.Id, true) || [];
    let secs = 0;
    
    rows.forEach((rw) => {
      secs += rw.Diff || 0;
    });

    let clock = OldHelper.copy(task.Clock);
    clock.TimePaused = secs;

    await Api.saveClock(clock);

    // Reload clocks
    reload.value = true;
    await loadClocks();
    Toast.success("Pause record deleted");
  });
};

const refreshAll = async () => {
  reload.value = true;
  await loadClocks();
  await loadTasks();
};

// Data Loading Functions
const loadClocks = async (bg = false) => {
  if (!reload.value && !bg) {
    return;
  }
  reload.value = false;
  loadingClocks.value = true;
  try {

  // Preserve open state and paused lists
  const open = {};
  const pausedLists = {};
  runningClocks.value.forEach(row => {
    if (row.Open) {
      open["r" + row.Id] = true;
      if (row.showPausedRows) {
        open["p" + row.Id] = true;
        pausedLists[row.Id] = row.PausedList; // Keep existing paused list
      }
    }
  });

  const clocks = await Api.loadClocks(bg);
  
  if (!clocks) return;
  
  // Update in-place to avoid re-rendering everything
  const newClockIds = new Set(clocks.map(c => c.Id));
  const existingClockIds = new Set(runningClocks.value.map(c => c.Id));
  
  // Remove clocks that no longer exist
  for (let i = runningClocks.value.length - 1; i >= 0; i--) {
    if (!newClockIds.has(runningClocks.value[i].Id)) {
      runningClocks.value.splice(i, 1);
    }
  }
  
  // Separate new clocks from existing ones
  const newClocks = [];
  const existingClocks = [];
  
  for (const newClock of clocks) {
    // Restore UI state
    newClock.Open = !!open["r" + newClock.Id];
    newClock.showPausedRows = !!open["p" + newClock.Id];
    
    // Load paused list if not already loaded or if we need to refresh it
    if (newClock.Clock?.Id && (!pausedLists[newClock.Id] || reload.value)) {
      try {
        newClock.PausedList = await Api.loadPauses(newClock.Clock.Id, true);
        pausedLists[newClock.Id] = newClock.PausedList;
      } catch (error) {
        console.error("Error loading pauses:", error);
        newClock.PausedList = [];
      }
    } else if (pausedLists[newClock.Id]) {
      // Keep existing paused list
      newClock.PausedList = pausedLists[newClock.Id];
    }
    
    if (existingClockIds.has(newClock.Id)) {
      existingClocks.push(newClock);
    } else {
      newClocks.push(newClock);
    }
  }
  
  // Update existing clocks in place
  for (const clock of existingClocks) {
    const existingIndex = runningClocks.value.findIndex(c => c.Id === clock.Id);
    if (existingIndex >= 0) {
      Object.assign(runningClocks.value[existingIndex], clock);
    }
  }
  
  // Add new clocks at the top (prepend in reverse order to maintain API order)
  for (let i = newClocks.length - 1; i >= 0; i--) {
    runningClocks.value.unshift(newClocks[i]);
  }
  } finally {
    loadingClocks.value = false;
  }
};

// Load scheduled tasks (assignments) for the selected date - filters by CompleteByDate
const loadScheduledTasks = async (bg = false) => {
  const acct = await appStore.getAccount();
  const date = Helper.dateFromString(taskListDate.value) || new Date();

  /* switch into ApiService 
  const rows = await ApiService.loadTimes({
    StartDate: new Date(Helper.dateToInput(date, Helper.DateFormat_Date) + " 00:00:00"),
    EndDate: new Date(Helper.dateToInput(date, Helper.DateFormat_Date) + " 23:59:59"),
    TechId: acct.user?.UserId,
    TimeType: "Assignments",  // This filters by CompleteByDate in backend
    IncludeRequest: true,
    IncludeContact: true,
    Page: 0
  });
  */
  
  const rows = await Api.loadTimes({
    StartDate: Helper.dateToInput(date, Helper.DateFormat_Date) + " 00:00:00",
    EndDate: Helper.dateToInput(date, Helper.DateFormat_Date) + " 23:59:59",
    TechId: acct.user?.UserId,
    TimeType: "Assignments",  // This filters by CompleteByDate in backend
    IncludeRequest: true,
    IncludeContact: true,
    Page: 0
  });
  
  return rows || [];
};

// Load completed work entries for the selected date - filters by WorkCompleteDate
const loadCompletedTasks = async (bg = false) => {
  const acct = await appStore.getAccount();
  const date = Helper.dateFromString(taskListDate.value) || new Date();

  const rows = await Api.loadTimes({
    StartDate: Helper.dateToInput(date, Helper.DateFormat_Date) + " 00:00:00",
    EndDate: Helper.dateToInput(date, Helper.DateFormat_Date) + " 23:59:59",
    TechId: acct.user?.UserId,
    TimeType: "Work",  // This filters by WorkCompleteDate in backend
    IncludeRequest: true,
    IncludeContact: true,
    Page: 0
  });

  return rows || [];
};

const loadTasks = async (bg = false) => {
  loadingTasks.value = true;
  try {
    // Make two separate API calls - one for scheduled, one for completed
    // This ensures we get correct data for each section
    const [scheduledRows, completedRows] = await Promise.all([
      loadScheduledTasks(bg),
      loadCompletedTasks(bg)
    ]);

    // DEBUG LOGGING
    console.log('=== loadTasks DEBUG ===');
    console.log('scheduledRows count:', scheduledRows.length);
    console.log('completedRows count:', completedRows.length);
    console.log('scheduledRows:', scheduledRows.map(t => ({ Id: t.Id, CompleteByDate: t.CompleteByDate })));
    console.log('completedRows:', completedRows.map(t => ({ Id: t.Id, WorkCompleteDate: t.WorkCompleteDate })));
    // END DEBUG
    
    // Merge results, with completed tasks taking precedence (they have more data)
    const taskMap = new Map();
    
    // Add scheduled tasks first
    scheduledRows.forEach(task => {
      taskMap.set(task.Id, task);
    });
    
    // Merge completed tasks (they may update existing scheduled entries)
    completedRows.forEach(task => {
      if (taskMap.has(task.Id)) {
        // Merge the data - completed task has more up-to-date info
        Object.assign(taskMap.get(task.Id), task);
      } else {
        taskMap.set(task.Id, task);
      }
    });
    
    const rows = Array.from(taskMap.values());

    if (!rows.length) {
      // If no results, clear the list
      scheduledTasks.value = [];
      return;
    }
  
    // Update in-place to avoid re-rendering
    const newTaskIds = new Set(rows.map(t => t.Id));
  
    // Remove tasks that no longer exist
    for (let i = scheduledTasks.value.length - 1; i >= 0; i--) {
      if (!newTaskIds.has(scheduledTasks.value[i].Id)) {
        scheduledTasks.value.splice(i, 1);
      }
    }
  
    // Update existing tasks and add new ones
    rows.forEach(newTask => {
      const existingIndex = scheduledTasks.value.findIndex(t => t.Id === newTask.Id);
    
      if (existingIndex >= 0) {
        // Update existing task in-place
        Object.assign(scheduledTasks.value[existingIndex], newTask);
      } else {
        // Add new task
        scheduledTasks.value.push(newTask);
      }
    });
  } finally {
    loadingTasks.value = false;
  }
};

const reloadClocks = async (bg = false) => {
  reload.value = true;
  await loadClocks(bg);
};

// Clock Ticker
const tickClocks = async () => {
  const now = new Date();

  runningClocks.value.forEach(row => {
    if (!row.Clock) return;
    
    const dte = new Date(row.Clock.Start);
    let paused = row.Clock.TimePaused || 0;
    
    // If clock is currently paused, freeze the timer at the pause time
    if (row.Clock.Paused) {
      const dtePaused = new Date(row.Clock.Paused);
      // Calculate time up to when it was paused (not continuing to count)
      const tmp = ch.calcDiff(dtePaused, dte, paused);
      row.Diff = tmp.hhmmss;
      row.DiffSeconds = tmp.seconds;
      row.DiffPaused = ch.calcPaused(row.Clock).hhmmss;
    } else {
      // Clock is running normally, count elapsed time
      const tmp = ch.calcDiff(now, dte, paused);
      row.Diff = tmp.hhmmss;
      row.DiffSeconds = tmp.seconds;
      row.DiffPaused = ch.calcPaused(row.Clock).hhmmss;
    }
  });

  running.value = window.setTimeout(tickClocks, 1000);

  // Auto-refresh every 60 seconds (only clocks, not tasks)
  // Skip if any modals are open to avoid disruption
  if (60 < ticks.value++) {
    // Only reload clocks in background - tasks don't change as frequently
    reloadClocks(true);
    ticks.value = 0;
  }
};

// Modal Functions
const modalDismiss = async (shouldReload) => {
  if (shouldReload) {
    await refreshAll();
  }
  modalVisible.value = false;
  router.push({ path: "/clock/list" });
};

const clockSuccess = async () => {
  // Force refresh to load new clock
  reload.value = true;
  await refreshAll();
  
  // Small delay to ensure DOM updates before closing modal
  await new Promise(resolve => setTimeout(resolve, 100));
  
  modalVisible.value = false;
  router.push({ path: "/clock/list" });
};

// Resume Wizard Modal Functions
const resumeModalDismiss = () => {
  resumeModalVisible.value = false;
  resumeTaskData.value = null;
};

const resumeSuccess = async () => {
  await refreshAll();
  resumeModalVisible.value = false;
  resumeTaskData.value = null;
};

// Quick Add Modal Functions
const openQuickAdd = (type, task) => {
  quickAddTask.value = task;
  
  // For Request-based clocks, use WorkOrder ID from Clock.RequestId
  // For Job-based clocks, use Job Request ID
  if (task.isRequestClock) {
    quickAddRequestId.value = task.Clock?.RequestId || 0; // WorkOrder ID
  } else {
    quickAddRequestId.value = task.RequestId || task.Request?.Id || 0; // Job ID
  }
  
  // Notes and Files use Contact.Id (FK to Contact PK); Parts/Expenses/Mileage use CustomerNumber
  const usesCustomerNumber = ['part', 'expense', 'mileage'];
  quickAddClientId.value = usesCustomerNumber.includes(type)
    ? (task.Contact?.CustomerNumber || task.ClientId || 0)
    : (task.Contact?.Id || task.ClientId || 0);
  quickAddTechId.value = task.AssignedTo || task.Technician?.Id || 0;
  
  const componentMap = {
    note: { component: NoteEdit, title: "Add Note" },
    part: { component: PartEdit, title: "Add Part" },
    expense: { component: ExpenseEdit, title: "Add Expense" },
    mileage: { component: MileageEdit, title: "Add Mileage" },
    file: { component: AttachmentForm, title: "Add File" }
  };
  
  const config = componentMap[type];
  if (config) {
    quickAddComponent.value = config.component;
    quickAddTitle.value = config.title;
    quickAddVisible.value = true;
  }
};

const quickAddDismiss = () => {
  quickAddVisible.value = false;
  quickAddComponent.value = null;
  quickAddTask.value = null;
  quickAddRequestId.value = 0;
  quickAddClientId.value = 0;
  quickAddTechId.value = 0;
};

const quickAddSaved = async () => {
  quickAddDismiss();
  await refreshAll();
};

// Camera / Photo Capture
const cameraInput = ref<HTMLInputElement | null>(null);
const photoTask = ref<any>(null);
const webcamVisible = ref(false);
const webcamVideo = ref<HTMLVideoElement | null>(null);
const webcamCanvas = ref<HTMLCanvasElement | null>(null);
const capturedImageData = ref<string | null>(null);
const isUploadingPhoto = ref(false);
let webcamStream: MediaStream | null = null;

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const capturePhoto = (task: any) => {
  photoTask.value = task;
  if (isMobileDevice()) {
    // Mobile: use native camera input
    if (cameraInput.value) {
      cameraInput.value.value = '';
      cameraInput.value.click();
    }
  } else {
    // Desktop: open webcam modal
    openWebcam();
  }
};

const getWebcamStream = async (constraints: MediaStreamConstraints): Promise<MediaStream> => {
  // Modern API
  if (navigator.mediaDevices?.getUserMedia) {
    return navigator.mediaDevices.getUserMedia(constraints);
  }
  
  // Legacy API fallback for older browsers
  const legacyGetUserMedia = (navigator as any).webkitGetUserMedia 
    || (navigator as any).mozGetUserMedia 
    || (navigator as any).msGetUserMedia;
  
  if (legacyGetUserMedia) {
    return new Promise((resolve, reject) => {
      legacyGetUserMedia.call(navigator, constraints, resolve, reject);
    });
  }
  
  // Check if we're in a secure context
  if (typeof window !== 'undefined' && !window.isSecureContext) {
    throw new Error('INSECURE_CONTEXT');
  }
  
  throw new Error('getUserMedia is not supported in this browser');
};

const openWebcam = async () => {
  capturedImageData.value = null;
  webcamVisible.value = true;
  // Wait for modal to render, then start webcam
  await new Promise(r => setTimeout(r, 300));
  try {
    const facingMode = isMobileDevice() ? 'environment' : 'user';
    webcamStream = await getWebcamStream({
      video: { facingMode, width: { ideal: 1280 }, height: { ideal: 720 } }
    });
    if (webcamVideo.value) {
      webcamVideo.value.srcObject = webcamStream;
    }
  } catch (err: any) {
    console.error('Could not access webcam:', err);
    let msg: string;
    if (err?.message === 'INSECURE_CONTEXT' || !window.isSecureContext) {
      msg = 'Camera requires a secure connection. Please access via https:// or localhost (not 127.0.0.1 or IP address).';
    } else if (err?.name === 'NotAllowedError') {
      msg = 'Camera access denied. Please allow camera permissions in your browser.';
    } else if (err?.name === 'NotFoundError') {
      msg = 'No camera found on this device.';
    } else {
      msg = `Could not access camera: ${err?.message || 'Unknown error'}`;
    }
    Toast.error(msg);
    closeWebcam();
  }
};

const stopWebcamStream = () => {
  if (webcamStream) {
    webcamStream.getTracks().forEach(track => track.stop());
    webcamStream = null;
  }
  if (webcamVideo.value) {
    webcamVideo.value.srcObject = null;
  }
};

const closeWebcam = () => {
  stopWebcamStream();
  capturedImageData.value = null;
  webcamVisible.value = false;
  if (!capturedImageData.value) {
    photoTask.value = null;
  }
};

const takeSnapshot = () => {
  const video = webcamVideo.value;
  const canvas = webcamCanvas.value;
  if (!video || !canvas) return;

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  ctx.drawImage(video, 0, 0);
  capturedImageData.value = canvas.toDataURL('image/jpeg', 0.85);
  stopWebcamStream();
};

const retakePhoto = () => {
  capturedImageData.value = null;
  openWebcam();
};

const uploadWebcamPhoto = async () => {
  if (!capturedImageData.value || !photoTask.value) return;
  isUploadingPhoto.value = true;

  try {
    const task = photoTask.value;
    const requestId = task.RequestId || task.Request?.Id || 0;

    // Convert data URL to Blob
    const res = await fetch(capturedImageData.value);
    const blob = await res.blob();
    const file = new File([blob], `photo_${Date.now()}.jpg`, { type: 'image/jpeg' });

    const dta = new FormData();
    dta.append("File", file);
    dta.append("Type", "request");
    dta.append("RequestId", String(requestId));
    await Api.saveFile(dta);

    Toast.success("Photo uploaded successfully");
    closeWebcam();
    photoTask.value = null;
    await refreshAll();
  } catch (err) {
    console.error('Photo upload failed:', err);
    Toast.error('Failed to upload photo');
  } finally {
    isUploadingPhoto.value = false;
  }
};

// Mobile camera input handler
const onPhotoCaptured = async (event: Event) => {
  const input = event.target as HTMLInputElement;
  const files = input.files;
  if (!files || files.length === 0 || !photoTask.value) return;

  const task = photoTask.value;
  const requestId = task.RequestId || task.Request?.Id || 0;

  for (let i = 0; i < files.length; i++) {
    const dta = new FormData();
    dta.append("File", files[i]);
    dta.append("Type", "request");
    dta.append("RequestId", String(requestId));
    await Api.saveFile(dta);
  }

  Toast.success("Photo uploaded successfully");
  photoTask.value = null;
  await refreshAll();
};

// Watchers
unbind.push(watch(() => taskListDate.value, () => {
  loadTasks();
}));

// Watch route to show/hide modal
unbind.push(watch(() => route.path, (newPath) => {
  if (newPath.includes('/clock/edit') || newPath.includes('/clock/stop')) {
    modalVisible.value = true;
    
    if (newPath.includes('/clock/stop')) {
      modalTitle.value = "Stop Clock";
      clockOperation.value = "stop";
      clockTaskId.value = route.params.type;
    } else {
      modalTitle.value = "Start Clock";
      clockOperation.value = "start";
      clockTaskId.value = route.params.type !== 'new' ? route.params.type : null;
    }
  } else {
    modalVisible.value = false;
  }
}, { immediate: true }));


// Lifecycle
onMounted(() => {
  if (running.value === null) {
    running.value = window.setTimeout(tickClocks, 1000);
  }

  reload.value = true;
  loadClocks();
  loadTasks();
  
  // Listen for clock started event from Dashboard's ClockWizard modal
  const clockStartedHandler = () => {
    console.debug('Clock started event received - refreshing clock list');
    reload.value = true;
    refreshAll();
  };
  
  // Events.on() returns an unbind function directly
  const unbindClockStarted = Events.on('clock:started', clockStartedHandler);
  unbind.push(unbindClockStarted);

  unbind.push(Events.on("task-update", (...args: any[]) => {
    // do we want to incorporate anything else? design / style ... 
    loadTasks();
  }))
});

onUnmounted(() => {
  if (running.value !== null) {
    window.clearTimeout(running.value);
    running.value = null;
  }
  
  unbind.forEach(fn => fn());
});

</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

/* STYLE OPTION 1: Subtle Left Border Accent (CURRENT) */
.running-clock {
  border: 1px solid #dee2e6;
  border-left: 4px solid #198754;
  background-color: #f8f9fa;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.paused-clock {
  border: 1px solid #dee2e6;
  border-left: 4px solid #ffc107;
  background-color: #fffbf0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.scheduled-task {
  border: 1px solid #dee2e6;
  background-color: #ffffff;
}

.complete-task {
  border: 1px solid #dee2e6;
  border-left: 4px solid #6f42c1;
  background-color: #f8f9fa;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

/* Hover effects */
.running-clock:hover,
.paused-clock:hover,
.scheduled-task:hover,
.complete-task:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: box-shadow 0.2s ease;
}

/* Clock Action Buttons */
.clock-action-btn {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  min-width: 44px;
  transition: all 0.2s ease;
}

.clock-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
}

.clock-action-btn:active {
  transform: translateY(0);
}

/*  
STYLE OPTION 2: Top Border Accent (Uncomment to use)

.running-clock {
  border: 1px solid #dee2e6;
  border-top: 3px solid #198754;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.paused-clock {
  border: 1px solid #dee2e6;
  border-top: 3px solid #ffc107;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
*/

/* 
STYLE OPTION 3: Subtle Background Gradient (Uncomment to use)

.running-clock {
  border: 1px solid #c3e6cb;
  background: linear-gradient(to right, #d4edda 0%, #ffffff 10%);
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.paused-clock {
  border: 1px solid #ffeaa7;
  background: linear-gradient(to right, #fff3cd 0%, #ffffff 10%);
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
*/

.bg-purple {
  background-color: #6f42c1 !important;
  color: #fff !important;
}
</style>
